/* eslint-disable */
import { compose, withProps, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import { routes as routesSelector, params as paramsSelector } from 'ggApp/modules/router/selectors';

import AlternateLocaleLink from './AlternateLocaleLink';

const enhance = compose(
    connect(
        createStructuredSelector({
            routes: routesSelector,
            params: paramsSelector,
            activeStore: activeStoreSelector,
        }),
    ),
    withProps(({
        activeStore: { code },
    }) => ({
        isBusinessStore: code === 'business',
    })),
    branch(({ isBusinessStore }) => isBusinessStore, renderNothing),
);

export default enhance(AlternateLocaleLink);
